@if (visibility$ | async; as visible) {
  <div
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="visible"
    class="evim-snackbar evim-snackbar--{{color}}"
  >
    @if (!snackbar?.isPrimary) {
      <div class="evim-snackbar__action evim-snackbar__action--left">
        @if (leftAction) {
          <evi-mobile-snackbar-action [action]="leftAction"></evi-mobile-snackbar-action>
        }
      </div>
    }

    <div class="evim-snackbar__content">
      @if (icon && icon.name) {
        <unis-icon
          [icon]="icon.name"
          [font]="icon.font"
          [isSvg]="icon.isSvg"
          [sharp]="icon.sharp"
          [size]="icon.size"
          [color]="color"
        ></unis-icon>
      }

      <span
        class="evim-snackbar__text"
        data-testid="snackbar-message"
      >
        {{ snackbar?.message | optionalAsync }}
        @if (snackbar?.isPrimary && snackbar?.subMessage) {
          <span class="evim-snackbar__subtext">
            <br>
            {{ snackbar?.subMessage | optionalAsync }}
          </span>
        }
      </span>
    </div>

    @if (!snackbar?.isPrimary) {
      <div class="evim-snackbar__action evim-snackbar__action--right">
        @if (rightAction) {
          <evi-mobile-snackbar-action [action]="rightAction"></evi-mobile-snackbar-action>
        }
      </div>
    }
  </div>
}
